import { mapActions, mapGetters } from 'vuex'

import { applyUpdateSW, metaInfo, onUpdateSW } from '@/utils'

import render from './render'

import DefaultLayout from '@/layouts/default'
import SimpleLayout from '@/layouts/simple'

export default {
  name: 'App',

  mixins: [ metaInfo ],

  computed: {
    ...mapGetters({ token: 'authentication/token' }),

    layout() {
      switch (this.$route.name) {
        case 'documentation':
        case 'documentation.file':
        case 'debug': {
          if (this.token) {
            return DefaultLayout
          }

          return SimpleLayout
        }
        case 'pay':
        case 'pay.owner':
        case 'pay.webhook':
        case 'login':
        case 'registration':
        case 'recover':
        case 'recover.key': return SimpleLayout
        default: {
          if (this.token) {
            return DefaultLayout
          }
        }
      }
    }
  },

  watch: {
    $route(to) {
      const locale = to.params.locale || to.query.locale
      if (locale) {
        this.setLocale(locale)
      }
    }
  },

  created() {
    onUpdateSW(() => {
      this.showVersionNotify()
      this.setVersion()
    })
  },

  methods: {
    ...mapActions({
      setLocale: 'locale/setLocale',
      setVersion: 'version/set'
    }),

    showVersionNotify() {
      this.addSnackbar({
        text: this.getTranslate('misc.refreshSite'),
        type: 'info',
        button: {
          props: { label: this.getTranslate('misc.buttons.refresh') },
          on: {
            click: () => {
              return applyUpdateSW()
            }
          }
        },
        duration: 5 * 60 * 1000
      })
    }
  },

  render
}
